import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pgm-notice" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = {
  key: 0,
  class: "pa-4"
}
const _hoisted_5 = {
  key: 1,
  class: "notice-list"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "item-title" }
const _hoisted_8 = {
  key: 1,
  class: "new-badge"
}
const _hoisted_9 = { class: "item-author" }
const _hoisted_10 = { class: "item-date" }
const _hoisted_11 = {
  key: 2,
  class: "no-data-message"
}

import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';

interface Notice {
  nc_idx: number;
  nc_type: 'ADMIN' | 'CENTER';
  nc_category: 'NOTICE' | 'UPDATE' | 'EVENT' | 'URGENT';
  nc_sisul_code: string | null;
  nc_sisul_name: string | null;
  nc_writer_name: string;
  nc_title: string;
  nc_hit: number;
  nc_wdate: string;
  file_count: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PgmNotice',
  setup(__props) {

const router = useRouter();
const loading = ref(false);
const notices = ref<Notice[]>([]);
const searchQuery = ref('');

// 필터링된 공지사항
const filteredNotices = computed(() => {
  if (!searchQuery.value) return notices.value;
  
  const query = searchQuery.value.toLowerCase();
  return notices.value.filter(n => 
    n.nc_title?.toLowerCase().includes(query) ||
    n.nc_writer_name?.toLowerCase().includes(query)
  );
});

// 공지사항 목록 로드
const loadNotices = async () => {
  loading.value = true;
  try {
    const response = await axios.get('/api/notice/list', {
      params: { page: 1, limit: 50 },
      withCredentials: true
    });
    
    if (response.data.success) {
      notices.value = response.data.notices;
    }
  } catch (error) {
    console.error('공지사항 목록 로드 오류:', error);
  } finally {
    loading.value = false;
  }
};

// 상세 페이지로 이동
const goToDetail = (notice: Notice) => {
  router.push(`/pgm/notice/${notice.nc_idx}`);
};

// 글쓰기 페이지로 이동
const goToWrite = () => {
  router.push('/pgm/notice/write');
};

// 유틸리티 함수
const formatDate = (date: string) => {
  if (!date) return '-';
  const d = new Date(date);
  const today = new Date();
  
  if (d.toDateString() === today.toDateString()) {
    return d.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
  }
  
  return d.toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' });
};

const formatListDate = (date: string) => {
  if (!date) return '-';
  const d = new Date(date);
  return `${d.getFullYear()}.${String(d.getMonth()+1).padStart(2,'0')}.${String(d.getDate()).padStart(2,'0')}`;
};

const isNew = (date: string) => {
  if (!date) return false;
  const d = new Date(date);
  const now = new Date();
  return (now.getTime() - d.getTime()) < 3 * 24 * 60 * 60 * 1000;
};

const getCategoryColor = (category: string) => {
  switch (category) {
    case 'NOTICE': return 'primary';
    case 'UPDATE': return 'info';
    case 'EVENT': return 'success';
    case 'URGENT': return 'error';
    default: return 'grey';
  }
};

const getCategoryText = (category: string) => {
  switch (category) {
    case 'NOTICE': return '공지';
    case 'UPDATE': return '업데이트';
    case 'EVENT': return '이벤트';
    case 'URGENT': return '긴급';
    default: return category;
  }
};

onMounted(() => {
  loadNotices();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createVNode(_component_v_icon, { class: "mr-2" }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("mdi-bullhorn", -1)
          ]))]),
          _: 1
        }),
        _cache[2] || (_cache[2] = _createTextVNode(" 공지사항 ", -1))
      ]),
      _createVNode(_component_v_btn, {
        color: "white",
        variant: "flat",
        onClick: goToWrite
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createTextVNode(" 글쓰기 ", -1))
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_card, {
      class: "search-card",
      elevation: "1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, { class: "pa-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "8",
                  sm: "6",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: searchQuery.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                      "prepend-inner-icon": "mdi-magnify",
                      placeholder: "검색",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  sm: "3",
                  md: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "tonal",
                      onClick: loadNotices,
                      loading: loading.value,
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("mdi-refresh", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      class: "notice-list-card",
      elevation: "1"
    }, {
      default: _withCtx(() => [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_v_skeleton_loader, { type: "list-item-three-line@5" })
            ]))
          : (filteredNotices.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredNotices.value, (notice) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: notice.nc_idx,
                    class: "notice-list-item",
                    onClick: ($event: any) => (goToDetail(notice))
                  }, [
                    _createVNode(_component_v_chip, {
                      color: getCategoryColor(notice.nc_category),
                      size: "x-small",
                      variant: "flat",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getCategoryText(notice.nc_category)), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"]),
                    _createElementVNode("span", _hoisted_7, [
                      _createTextVNode(_toDisplayString(notice.nc_title) + " ", 1),
                      (notice.file_count > 0)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            size: "12",
                            color: "grey",
                            class: "ml-1"
                          }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createTextVNode("mdi-attachment", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (isNew(notice.nc_wdate))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "N"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(notice.nc_type === 'ADMIN' ? '관리자' : notice.nc_sisul_name || '-'), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(formatListDate(notice.nc_wdate)), 1)
                  ], 8, _hoisted_6))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_v_icon, {
                  size: "48",
                  color: "grey-lighten-1"
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("mdi-bulletin-board", -1)
                  ]))]),
                  _: 1
                }),
                _cache[8] || (_cache[8] = _createElementVNode("p", null, "공지사항이 없습니다", -1))
              ]))
      ]),
      _: 1
    })
  ]))
}
}

})